import React from 'react';

import Popover from 'antd/es/popover';

import SearchWithCheckboxes from '@common/react/components/UI/SearchWithCheckboxes/SearchWithCheckboxes';
import { BaseParams } from '@common/react/objects/BaseParams';
import { PaginationOptions } from '@common/react/components/Core/ItemsProvider/ItemsProvider';

interface FilterProps {
	type: string;
	onChange: (values: Array<number>) => void;
	loadRequest?: string;
	values?: Array<number>;
	initItems?: Array<any>;
	className?: string;
	additionalParams?: BaseParams;
	renderName?: (item) => React.ReactNode;
	renderItem?: (item) => React.ReactNode;
	pagination?: PaginationOptions;
	title?: string;
	titleClassName?: string;
	isMobile?: boolean;
	getOptionProps?: any;
	initLoadedAll?: boolean;
	containerClassName?: string;
}

const Filter: React.FC<FilterProps> = (props) => {
	const {
		isMobile,
		values,
		onChange,
		title,
		titleClassName,
		additionalParams,
		renderName = (item) => item.name,
		renderItem = renderName,
		getOptionProps = (item) => ({
			item,
			title: item.name,
			value: item.id,
			children: <>
				{renderName(item)}
			</>,
		}),
		containerClassName = 'pull-left ml10',
		pagination = {
			current: 1,
			pageSize: 100,
		},
		...rest
	} = props;

	const node = (<SearchWithCheckboxes
		title={title}
		titleClassName={titleClassName}
		additionalParams={additionalParams}
		values={values}
		onChange={onChange}
		renderItem={renderItem}
		renderName={renderName}
		pagination={pagination}
		{...rest}
	/>);

	return isMobile ? <>
		{node}
	</> : <>
		<div className={containerClassName}>
			<Popover
				trigger={['click']}
				content={node}
				placement="bottom"
				overlayClassName="checkbox-list-popover"
			>
				<button type="button" className="checkbox-list-button">
					{title}
					{values?.length ? <button title="Clear" type="button" className="badge" onClick={() => onChange([])}>
						<span>{values?.length}</span>
						<i className="fa fa-times" />
					</button> : null}
					<i className="fa fa-angle-down" />
				</button>
			</Popover>
		</div>
	</>;
};

export default Filter;
